export const subscriptionPopupConfig = {
  ON_LOAD: 'ON_LOAD',
  NO_POPUP: 'NO_POPUP',
  AFTER_LANDING: 'AFTER_LANDING',
  COOKIE_NAME: 'spcnt',
  COOKIE_EXPIRES: 36500,
};

export const isSubscriptionPopupVisibile = (cookieValue) => {
  const { popupMaxCount } = jrConfigGlobal.subscription;

  switch (jrConfigGlobal.subscription.popupPolicyType) {
    case subscriptionPopupConfig.ON_LOAD:
      return cookieValue === null || cookieValue < popupMaxCount;
    case subscriptionPopupConfig.AFTER_LANDING:
      return cookieValue !== null && cookieValue < popupMaxCount;
    case subscriptionPopupConfig.NO_POPUP:
      return false;
    default:
      return false;
  }
};
